(function () {
  class PlProduct extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-plp-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.idInput = this.querySelector('[data-plp-id]');
      this.priceEl = this.querySelector('[data-plp-price]');
      this.atcBtn = this.querySelector('[data-plp-atc]');
      this.atcText = this.querySelector('[data-plp-atc-text]');
      this.colourValue = this.querySelector('[data-plp-colour-value]');
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';

      this.optionInputs = Array.from(this.querySelectorAll('[data-plp-option]'));
      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });

      this.initGallery();
      this.initAccordions();
      this.initSizeGuide();
      this.initLightbox();
      this.onOptionChange(true);
    }

    initLightbox() {
      this.lightbox = this.querySelector('[data-plp-lightbox]');
      if (!this.lightbox) return;
      this.lbTrack = this.lightbox.querySelector('[data-plp-lightbox-track]');
      this.lbItems = Array.from(this.lightbox.querySelectorAll('[data-plp-lightbox-item]'));
      this.lbCurrent = this.lightbox.querySelector('[data-plp-lightbox-current]');
      this.lbIndex = 0;

      this.querySelectorAll('[data-plp-zoom]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openLightbox(parseInt(btn.dataset.plpZoom || '0', 10));
        });
      });

      this.querySelectorAll('.plp__media-item').forEach((item) => {
        if (item.querySelector('video')) return;
        item.addEventListener('click', () => {
          this.openLightbox(parseInt(item.dataset.plpMediaIndex || '0', 10));
        });
      });

      this.lightbox.querySelectorAll('[data-plp-lightbox-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeLightbox());
      });
      const prev = this.lightbox.querySelector('[data-plp-lightbox-prev]');
      const next = this.lightbox.querySelector('[data-plp-lightbox-next]');
      if (prev) prev.addEventListener('click', () => this.lbGo(-1));
      if (next) next.addEventListener('click', () => this.lbGo(1));

      if (this.lbTrack) {
        this.lbTrack.addEventListener(
          'scroll',
          () => {
            const i = Math.round(this.lbTrack.scrollLeft / this.lbTrack.clientWidth);
            this.lbIndex = i;
            if (this.lbCurrent) this.lbCurrent.textContent = i + 1;
          },
          { passive: true }
        );
      }

      document.addEventListener('keydown', (e) => {
        if (!this.lightbox || this.lightbox.hidden) return;
        if (e.key === 'Escape') this.closeLightbox();
        if (e.key === 'ArrowLeft') this.lbGo(-1);
        if (e.key === 'ArrowRight') this.lbGo(1);
      });
    }

    openLightbox(index) {
      if (!this.lightbox || !this.lbTrack) return;
      this.lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      this.lbScrollTo(index, 'auto');
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    lbGo(dir) {
      const n = Math.min(Math.max(this.lbIndex + dir, 0), this.lbItems.length - 1);
      this.lbScrollTo(n, 'smooth');
    }

    lbScrollTo(index, behavior) {
      const item = this.lbItems[index];
      if (!item || !this.lbTrack) return;
      this.lbIndex = index;
      this.lbTrack.scrollTo({ left: item.offsetLeft, behavior: behavior || 'smooth' });
      if (this.lbCurrent) this.lbCurrent.textContent = index + 1;
    }

    initSizeGuide() {
      this.modal = this.querySelector('[data-plp-sizeguide]');
      if (!this.modal) return;
      this.querySelectorAll('[data-plp-sizeguide-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.modal.hidden = false;
          document.body.style.overflow = 'hidden';
        });
      });
      this.querySelectorAll('[data-plp-sizeguide-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeSizeGuide());
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeSizeGuide();
      });
    }

    closeSizeGuide() {
      if (!this.modal) return;
      this.modal.hidden = true;
      document.body.style.overflow = '';
    }

    selectedOptions() {
      const opts = [];
      this.optionInputs.forEach((input) => {
        if (input.checked) opts[parseInt(input.dataset.plpPosition, 10) - 1] = input.value;
      });
      return opts;
    }

    matchVariant(opts) {
      return this.variants.find((v) =>
        v.options.every((o, i) => opts[i] === undefined || o === opts[i])
      );
    }

    onOptionChange(initial) {
      const opts = this.selectedOptions();
      const variant = this.matchVariant(opts);

      this.updateSizeAvailability(opts);

      if (!variant) {
        this.setAtc('unavailable');
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;

      if (this.priceEl) {
        let html = this.money(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html =
            '<s>' + this.money(variant.compare_at_price) + '</s> ' +
            '<span class="plp__price-sale">' + this.money(variant.price) + '</span>';
        }
        this.priceEl.innerHTML = html;
      }

      if (this.colourValue && variant.option_color) {
        this.colourValue.textContent = variant.option_color;
      }

      if (!variant.available) {
        this.setAtc('soldout');
      } else {
        this.setAtc('add');
      }

      if (!initial) {
        this.updateUrl(variant.id);
        this.scrollToMedia(variant.featured_media_id);
      }
    }

    updateSizeAvailability(opts) {
      const sizePos = parseInt(this.dataset.sizePosition || '0', 10);
      if (!sizePos) return;
      this.optionInputs
        .filter((i) => parseInt(i.dataset.plpPosition, 10) === sizePos)
        .forEach((input) => {
          const trial = opts.slice();
          trial[sizePos - 1] = input.value;
          const v = this.variants.find((x) =>
            x.options.every((o, i) => trial[i] === undefined || o === trial[i])
          );
          const available = v && v.available;
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('plp__size--soldout', !available);
        });
    }

    setAtc(state) {
      if (!this.atcBtn) return;
      const labels = {
        add: this.atcBtn.dataset.labelAdd || 'Add to bag',
        soldout: this.atcBtn.dataset.labelSoldout || 'Sold out',
        unavailable: this.atcBtn.dataset.labelUnavailable || 'Unavailable',
      };
      if (this.atcText) this.atcText.textContent = labels[state];
      this.atcBtn.disabled = state !== 'add';
    }

    money(cents) {
      const amount = (cents / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      const amountNoDecimals = Math.round(cents / 100).toLocaleString();
      return this.moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals);
    }

    updateUrl(variantId) {
      if (!window.history || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    scrollToMedia(mediaId) {
      if (!mediaId || window.innerWidth > 1054) return;
      const target = this.querySelector('[data-plp-media-id="' + mediaId + '"]');
      const track = this.querySelector('[data-plp-track]');
      if (target && track) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    initGallery() {
      this.track = this.querySelector('[data-plp-track]');
      this.dots = Array.from(this.querySelectorAll('[data-plp-dot]'));
      if (!this.track || !this.dots.length) return;
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const items = this.track.querySelectorAll('.plp__media-item');
          if (items[i]) this.track.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
        });
      });
      this.track.addEventListener(
        'scroll',
        () => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
        },
        { passive: true }
      );
    }

    initAccordions() {
      Array.from(this.querySelectorAll('[data-plp-acc]')).forEach((btn) => {
        btn.addEventListener('click', () => {
          const panel = btn.nextElementSibling;
          const open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
        });
        if (btn.getAttribute('aria-expanded') === 'true') {
          const panel = btn.nextElementSibling;
          if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }
  }

  if (!customElements.get('pl-product')) customElements.define('pl-product', PlProduct);
})();